const toSafeNumber = (value: any): number => {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

export const normalizeInvoiceListTaxRate = (value: any): string => {
  const rawValue =
    value && typeof value === "object"
      ? value.code ?? value.name ?? value.taxValue
      : value;
  const normalizedValue = `${rawValue ?? ""}`.trim();

  const specialTaxRates = {
    "-1": "KCT",
    "-2": "KKKNT",
    "-3": "KHAC",
    KCT: "KCT",
    KKKNT: "KKKNT",
    KHAC: "KHAC",
  };
  const specialTaxRate =
    specialTaxRates[normalizedValue.toUpperCase()];
  if (specialTaxRate) {
    return specialTaxRate;
  }

  const numericTaxRate = normalizedValue.replace(/%$/, "");
  if (numericTaxRate !== "" && Number.isFinite(Number(numericTaxRate))) {
    return `${Number(numericTaxRate)}%`;
  }

  return normalizedValue;
};

const getTaxRate = (value: any): number => {
  const normalizedValue = `${value ?? ""}`.trim().replace(/%$/, "");
  return toSafeNumber(normalizedValue);
};

export const calculateInvoiceListItemDiff = (item: any) => {
  const normalizedItem = {
    ...item,
    originalTaxRate: normalizeInvoiceListTaxRate(item?.originalTaxRate),
    updatedTaxRate: normalizeInvoiceListTaxRate(item?.updatedTaxRate),
  };

  return {
    ...normalizedItem,
    beforeTaxAmountDiff:
      toSafeNumber(normalizedItem.updatedAmountBeforeTax) -
      toSafeNumber(normalizedItem.originalAmountBeforeTax),
    taxAmountDiff:
      toSafeNumber(normalizedItem.updatedTax) -
      toSafeNumber(normalizedItem.originalTax),
    discountAmountDiff:
      toSafeNumber(normalizedItem.updatedDiscountAmount) -
      toSafeNumber(normalizedItem.originalDiscountAmount),
    amountAfterTaxDiff:
      toSafeNumber(normalizedItem.updatedAmountAfterTax) -
      toSafeNumber(normalizedItem.originalAmountAfterTax),
  };
};

export const recalculateUpdatedInvoiceListItem = (
  item: any,
  changedField: string,
) => {
  const calculatedItem = { ...item };
  const shouldCalculateAmountBeforeTax = [
    "updatedQuantity",
    "updatedUnitPrice",
  ].includes(changedField);
  const shouldCalculateTax =
    shouldCalculateAmountBeforeTax ||
    ["updatedAmountBeforeTax", "updatedTaxRate"].includes(changedField);
  const shouldCalculateAmountAfterTax =
    shouldCalculateTax ||
    ["updatedTax", "updatedDiscountAmount"].includes(changedField);

  if (shouldCalculateAmountBeforeTax) {
    calculatedItem.updatedAmountBeforeTax =
      toSafeNumber(calculatedItem.updatedQuantity) *
      toSafeNumber(calculatedItem.updatedUnitPrice);
  }

  if (shouldCalculateTax) {
    calculatedItem.updatedTax =
      (toSafeNumber(calculatedItem.updatedAmountBeforeTax) *
        getTaxRate(calculatedItem.updatedTaxRate)) /
      100;
  }

  if (shouldCalculateAmountAfterTax) {
    calculatedItem.updatedAmountAfterTax =
      toSafeNumber(calculatedItem.updatedAmountBeforeTax) +
      toSafeNumber(calculatedItem.updatedTax) -
      toSafeNumber(calculatedItem.updatedDiscountAmount);
  }

  return calculateInvoiceListItemDiff(calculatedItem);
};
